const areas = {
	el: {
		header: document.querySelector('header'),
		asideToggleMobile: document.querySelector('.js-toggle-aside'),
		sticky: document.querySelector('.sticky'),
		areasArticles: document.querySelectorAll('.areas'),
		areasScrollItem: document.querySelectorAll('.sticky [data-scroll]'),
		areasStickyItem: document.querySelectorAll('.sticky__item'),
		areasStickyItemCopy: document.querySelector('.sticky__item-sticky-copy'),
		areasFilter: document.querySelectorAll('.js-filter-courses'),
		articlesContainer: document.querySelectorAll('.content__article'),
		courses: document.querySelectorAll('[data-filter-courses]'),
		cardsBlock: document.querySelectorAll('.card-border__block')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 80em)')
	},

	fxaAreasFilter() {
		this.el.areasFilter.forEach(el => el.addEventListener('change', e => {
			setTimeout(() => window.dispatchEvent(new Event('scroll')), 100)

			this.el.sticky.classList.contains('is-aside-open') ? this.el.sticky.classList.remove('is-aside-open') : ''

			const value = e.currentTarget.value

			if (value === '-1') {
				[...this.el.courses, ...this.el.cardsBlock, ...this.el.articlesContainer].forEach(el => el.removeAttribute('style'))
			}

			else {
				this.el.articlesContainer.forEach(el => el.removeAttribute('style'))
				const spacingBetweenArticles = 2 //20px

				setTimeout(() => this.el.articlesContainer.forEach(el => el.style.height = `${el.offsetHeight/10 + spacingBetweenArticles}rem`), 100)

				const filtered = [...this.el.courses].filter(el => el.dataset.filterCourses === value)

				this.el.courses.forEach(el => {
					el.style.display = 'none'
					this.el.cardsBlock.forEach(el => el.style.display = 'none')

				})

				filtered.forEach(el => {
					el.style.display = 'block'
					el.closest('.card-border__block').style.display = 'block'
				})
			}
		}))
	},

	fxAreasSetActive(element, index) {
		if (window.pageYOffset >= element.offsetTop - this.el.header.offsetHeight - (this.el.asideToggleMobile && !this.vars.extraLargeAndUp.matches ? this.el.asideToggleMobile.offsetHeight : 0)) {
			[...this.el.areasScrollItem, ...this.el.areasStickyItem].forEach(el => el.classList.remove('is-active'))
			if (this.el.areasScrollItem[index])
				this.el.areasScrollItem[index].classList.add('is-active')

			if (this.el.areasStickyItem[index])
				this.el.areasStickyItem[index].classList.add('is-active')

			if (!this.vars.extraLargeAndUp.matches)
				this.el.areasStickyItemCopy.textContent = document.querySelector('.sticky__item.is-active').textContent
		}
	},

	events() {
		//set mobile item
		this.el.areasStickyItemCopy.textContent = this.el.areasStickyItem[0].textContent

		this.el.asideToggleMobile.addEventListener('click', e => {
			e.currentTarget.parentElement.classList.toggle('is-aside-open')
			this.el.areasStickyItemCopy.textContent = document.querySelector('.sticky__item.is-active') ? document.querySelector('.sticky__item.is-active').textContent : ''
		})
		this.el.areasArticles.forEach((el, i) => window.addEventListener('load', e => {
			//highlight items while scroll
			e.currentTarget.addEventListener('scroll', () => this.fxAreasSetActive(el, i))
			//on load
			this.fxAreasSetActive(el, i)
		}))
	},

	init() {
		if (!this.el.sticky) return
		this.events()
		this.fxaAreasFilter()
	}

}

areas.init()